import { LoginProps } from "@lib/common-interfaces";

export interface ReturnUrls {
  original: string;
  github: string;
  aad: string;
  facebook: string;
  google: string;
}

export class LoginUrlHelper {
  public static buildReturnUrls(originalUrl: string, props: LoginProps): ReturnUrls {
    const appInvitationReturnUrl =
        props.appInvitation && props.appInvitation.inviteType !== "tester"
          ? `?original_url=/invitations/app/${props.appInvitation.token}&app_invitation=${props.appInvitation.token}`
          : null,
      organizationInvitationReturnUrl = !!props.organizationInvitation
        ? `?original_url=/invitations/org/${props.organizationInvitation.token}&organization_invitation=${props.organizationInvitation.token}`
        : null;

    const urls: ReturnUrls = {
      original: originalUrl,
      github: "/auth/github" + (appInvitationReturnUrl || organizationInvitationReturnUrl || originalUrl),
      aad: "/auth/aad" + (appInvitationReturnUrl || organizationInvitationReturnUrl || originalUrl),
      facebook: "/auth/facebook" + (appInvitationReturnUrl || organizationInvitationReturnUrl || originalUrl),
      google: "/auth/google" + (appInvitationReturnUrl || organizationInvitationReturnUrl || originalUrl)
    };

    return urls;
  }
}
